// extracted by mini-css-extract-plugin
export default {"productGallery":"XG-z","inQuickShop":"YG-z"};